// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cc5d1b3e","239":"981c17bb","453":"006e3d96","455":"735b82a0"}[chunkId] + ".chunk.js";
};